<!--  -->
<template>
    <div class="SpecialConfig">
        <div class="special_title padding-20 bgc box-shadow">
            <div class="left_name">专题名称：{{currenttop.topicname}}</div>
            <div class="right_return" @click="returnArticleTGList">返回投稿列表</div>
        </div>
        <el-tabs v-model="activeName" class="padding-20 bgc box-shadow">
            <el-tab-pane label="专题分类" name="first" v-if="currenttop.topiccode!='VCA'">
                <SpecialClassify :currenttop="currenttop" />
            </el-tab-pane>
            <el-tab-pane label="广告配置" name="second" v-if="currenttop.topiccode!='VCA'">
                <AdvertisingConfig ref="advertisingConfig" :currenttop="currenttop" />
            </el-tab-pane>
            <el-tab-pane label="资讯管理" name="third">
                <MessageManage :currenttop="currenttop" />
            </el-tab-pane>
            <el-tab-pane label="专题收集问卷" name="fourth">
                <MessageGather :currenttop="currenttop" />
            </el-tab-pane>
            <el-tab-pane label="专题报名问卷" name="fifth" v-if="currenttop.topiccode!='VCA'">
                <ReportMessage :currenttop="currenttop" />
            </el-tab-pane>
            <el-tab-pane label="落地咨询问卷" name="sixth" v-if="currenttop.topiccode!='VCA'">
                <SxyProductForm :currenttop="currenttop" />
            </el-tab-pane>
        </el-tabs>
        <div class="btn padding-20 bgc box-shadow" v-if="activeName === 'second'">
            <!-- <el-button>取消</el-button> -->
            <el-button type="primary" @click="submit">提交</el-button>
        </div>
    </div>
</template>

<script>
import AdvertisingConfig from './components/advertisingConfig'
import MessageGather from './components/messageGather'
import MessageManage from './components/messageManage'
import SpecialClassify from './components/specialClassify'
import ReportMessage from './components/reportMessage'
import SxyProductForm from './components/sxyProductForm'
export default {
    data() {
        return {
            activeName: this.$route.query.activeName ? this.$route.query.activeName :(this.$route.query.topiccode=='VCA'?'third':'first'),
            currenttop: {
                topicname: this.$route.query.topicname ? this.$route.query.topicname : '',
                topiccode: this.$route.query.topiccode ? this.$route.query.topiccode : ''
            }
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        console.log(this.$route)
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        returnArticleTGList() {
            this.$router.push({
                name: 'ArticleTGList'
            })
        },
        submit() {
            this.$refs.advertisingConfig.uploadSxyTopicinfo()
        }
    },
    components: {
        AdvertisingConfig,
        MessageGather,
        MessageManage,
        SpecialClassify,
        ReportMessage,
        SxyProductForm
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .SpecialConfig {
        .special_title {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left_name {
                font-size: 16px;
                color: #303133;
            }
            .right_return {
                cursor: pointer;
                font-size: 14px;
                color: #409EFF;
            }
        }
        .btn {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            .el-button--primary {
                // margin-left: 32px;
            }
        }
    }
</style>